import * as React from "react";

function SvgPlanetNeptune(props) {
  return (
    <svg viewBox="0 0 225.86 225.86" {...props}>
      <defs>
        <radialGradient
          id="planet-neptune_svg__d"
          cx={-1682.83}
          cy={1211.72}
          r={122.47}
          gradientTransform="matrix(.03 -.89 .91 -.16 -1009.75 -1240.81)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#f4f4f4" />
          <stop offset={1} />
        </radialGradient>
        <radialGradient
          id="planet-neptune_svg__f"
          cx={-1682.83}
          cy={1211.72}
          r={122.47}
          gradientTransform="matrix(.03 -.89 .91 -.16 -1009.75 -1240.81)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#fff" />
          <stop offset={1} stopColor="#f3f9f7" />
        </radialGradient>
        <filter
          id="planet-neptune_svg__a"
          x={9.46}
          y={-8212.22}
          width={134.34}
          height={32766}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <filter
          id="planet-neptune_svg__c"
          x={9.46}
          y={13.28}
          width={134.34}
          height={133.01}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <mask
          id="planet-neptune_svg__e"
          x={9.46}
          y={13.28}
          width={134.34}
          height={133.01}
          maskUnits="userSpaceOnUse"
        >
          <g
            mask="url(#planet-neptune_svg__b)"
            filter="url(#planet-neptune_svg__c)"
          >
            <path
              d="M35.69 37.15c28.47-27.37 74-32.69 97.85-8.18s2.17 46.62-25.06 80.46c-22.37 27.79-60.83 51-84.69 26.53S7.21 64.51 35.69 37.15z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="url(#planet-neptune_svg__d)"
            />
          </g>
        </mask>
      </defs>
      <g data-name="Layer 2">
        <circle cx={112.93} cy={112.93} r={112.93} fill="#2760fb" />
        <path
          d="M27.77 39a93.23 93.23 0 11-6 7.51 112.85 112.85 0 0020.68 154.81c48.73 38.82 119.79 30.71 158.72-18.1A112.87 112.87 0 00183.4 24.54C135.93-13.28 67.27-6.55 27.77 39z"
          fill="#0062bc"
        />
        <path
          d="M174.78 171.84a117.22 117.22 0 01-138.06 24.7 113.18 113.18 0 00158.49-6.38C238 144.75 235.38 72.7 189.8 30.31c-.5-.46-.7 0-1.21-.46C215.62 73 212 132.06 174.78 171.84z"
          style={{
            mixBlendMode: "multiply",
          }}
          fill="#296496"
          opacity={0.69}
        />
        <path
          d="M210.25 99.56h-.42a.71.71 0 000 1.42h.42a.71.71 0 000-1.42z"
          fill="#fffae6"
        />
        <path
          d="M99 16.33c3.67-4.9 7-10.33 8.5-16.19a112.91 112.91 0 00-93.32 58c32.69.27 65.18-15.65 84.82-41.81z"
          fill="#2258b7"
        />
        <path
          d="M109.07 211.3A89 89 0 0083.55 222a113 113 0 00126.32-51.11 108.19 108.19 0 01-46.11 29.24c-17.76 5.62-36.65 6.54-54.69 11.17zM177.21 160.53c-21.36 9.75-45.41 17-62.87 32.71-7.43 6.67-18.73 5.39-28.68 4.61a165.47 165.47 0 00-44.2 2.51 112.79 112.79 0 0018.47 12.3c15.14-2.54 30.22-5.49 44.76-10.36 23-7.68 44.08-19.94 65-32.12l49.44-28.77c1.2-.7 2.41-1.4 3.6-2.13.59-2.49 1.11-5 1.53-7.54-13.26 12.48-30.26 21.13-47.05 28.79z"
          fill="#055899"
        />
        <path
          d="M48.14 84.53C57 79.16 64.76 72 74 67.3c8.11-4.16 17.13-6.3 25.26-10.44C115.7 48.49 130 32.61 132.81 14.5a1.09 1.09 0 00-1.93-.85c-12.16 15-29.34 23.73-42 38.63-3.35 3.94-9.07 4.76-14.24 4.78S64 56.65 59.37 59c-1.71.85-3.36 2.24-3.69 4.12s.76 3.76 1 5.68c.65 4.63-3.75 8.73-8.36 9.51s-8-1.66-12.3-3.51c-3.24-1.39-6.73 2.35-8.35 4.82a6.85 6.85 0 01-4 2.92c-5.54 1.4-6.71-5.77-11-7.39-2.09-.78-4.36-.08-6.44.81a112.17 112.17 0 00-5.34 23c16.67-2.12 33.02-5.81 47.25-14.43z"
          fill="#2258b7"
        />
        <path
          d="M31.79 173.15c9.17-3.47 17.53-9 27-11.7 4.07-1.17 8.35-1.83 12.09-3.79 6-.87 12-1.75 17.88-3 30.9-6.27 59-21 85.69-38.15a5.76 5.76 0 004 3.9c3.56.78 6.66-2.5 8.42-5.68s3.34-6.94 6.71-8.31c4.21-1.71 9.56 1.11 13.35-1.41 2.66-1.77 3.25-5.34 4.53-8.27 2.14-4.91 6.53-8.38 10.44-12l.36-.35a112.06 112.06 0 00-9.16-23.68c-12.7 21-38 32.28-54.79 50.77-5.84 6.41-10.73 13.79-17.61 19.06-9.89 7.58-22.72 10-35.07 11.55-19.41 2.51-39 3.67-58.09 8.14q-5.24 1.23-10.42 2.85c-9.93-1.25-20.14-2.29-29.29 1A112.07 112.07 0 0019.23 176a43.23 43.23 0 0012.56-2.85z"
          fill="#0063b7"
        />
        <path
          d="M53.48 120.16A115.46 115.46 0 013 138.65c.44 1.89.92 3.76 1.46 5.61 14.36-.72 28.64-4.75 42.1-10.08 18.45-7.32 35.87-17 54.27-24.47 22.56-9.13 46.66-14.89 67.62-27.26 14.84-8.77 28.18-22 34.56-37.64a112.84 112.84 0 00-16.59-17.6A93.33 93.33 0 01134.74 82c-16.59 6.83-35.08 8.75-51 17.1-10.86 5.73-20.02 14.23-30.26 21.06z"
          fill="#325eb5"
        />
        <path
          d="M18.93 123c6.92-1.75 14.4-.25 21.19-2.44 6-1.94 10.74-6.52 15.24-11l7.79-7.69a2.5 2.5 0 00-2.62-4.12c-19.86 7.43-39.89 14.47-60.42 19.42a113 113 0 001.48 14.59c5.75-3.06 11.04-7.17 17.34-8.76z"
          fill="#2258b7"
        />
        <path
          d="M222.82 86.94c-2.92 1.29-4.17 4.52-5.33 7.43A88.89 88.89 0 01164.07 145c-15.3 5.16-31.67 6-47.53 9-12.82 2.46-25.91 6.77-35.83 14.94a4 4 0 002.69 7c16.17-.73 31.8-9.14 47.26-15.14 18.36-7.11 37.86-11 56.09-18.44 15.12-6.16 29.77-15.38 39.09-28.52v-.06a113.16 113.16 0 00-3.02-26.84z"
          fill="#055899"
        />
        <path
          d="M126.89 70c4.6-2.16 8.16-6 11.27-10.06s5.89-8.33 9.55-11.86c2.12-2 4.53-3.82 6.15-6.27s2.27-5.85.61-8.27-5.44-3-8.26-1.85-4.89 3.65-6.54 6.21-3 5.34-5.08 7.62c-3.84 4.28-9.51 6.34-14.33 9.48s-9.18 8.55-7.83 14.14c4 3.15 9.85 3.03 14.46.86z"
          fill="#2258b7"
        />
        <path
          d="M220.6 78.82l-1.32 2.73c-.5 1-1.07 2-1.64 3s-1.13 2.15-1.79 3.24-1.36 2.22-2.07 3.38-1.44 2.34-2.26 3.51-1.59 2.4-2.45 3.6c-1.81 2.35-3.53 4.87-5.59 7.2s-4.1 4.72-6.22 7.06c-2.27 2.19-4.46 4.47-6.82 6.49s-4.72 4-7 5.83c-1.17.91-2.38 1.73-3.53 2.57s-2.29 1.66-3.46 2.36l-3.33 2.16c-1.08.69-2.18 1.26-3.21 1.86l-3 1.71-2.76 1.4c-1.72.9 1.3-.52 0 0-2.55 1.15-10.6 7.84-10.6 7.84l2.91-1.27 4.35-1.29c1.39-.39 3-1 4.9-1.74l3-1.15q1.56-.66 3.24-1.47c1.12-.54 2.31-1.05 3.49-1.68l3.64-2c1.27-.67 2.51-1.45 3.76-2.27s2.57-1.61 3.85-2.49c2.51-1.85 5.14-3.72 7.61-5.88s4.9-4.41 7.32-6.7c2.24-2.46 4.62-4.8 6.61-7.42s4-5.16 5.75-7.71c.85-1.3 1.63-2.63 2.42-3.91a40.81 40.81 0 002.21-3.78 78.92 78.92 0 003.5-7.25c.15-.35.28-.67.42-1q-.85-3.54-1.93-6.93zM98.41 89c-2.36.66-4.67 1.34-6.93 2.12s-4.42 1.39-6.56 2.28l-3 1.22L79 96c-1.93.91-3.65 1.94-5.33 2.88a52.45 52.45 0 00-4.53 3.06 43.27 43.27 0 00-6.61 6l-2.15 2.5c-.55.79-1 1.48-1.36 2-.73 1.1-1.11 1.69-1.11 1.69l2.25 1.54 1.27-1.39c.41-.45.91-1 1.48-1.68l2.24-2.06a31.25 31.25 0 012.93-2.34 42.74 42.74 0 013.65-2.49c1.29-.91 2.86-1.6 4.38-2.51s3.29-1.63 5.08-2.35l2.73-1.14 3-1.09c1.94-.71 4.16-1.29 6.3-2s4.45-1.34 6.8-2 4.7-1.35 7.18-2.19c5-1.64 9.7-3.59 14.75-5.78 2.45-1.18 5-2.18 7.41-3.48l3.69-1.82 3.61-2c2.48-1.21 4.74-2.8 7.12-4.18 1.17-.71 2.27-1.53 3.41-2.3s2.29-1.51 3.32-2.39c2.1-1.73 4.29-3.33 6.21-5.2l2.93-2.69 2.74-2.82a71.24 71.24 0 005.08-5.74 71 71 0 004.35-5.91 97.48 97.48 0 006.47-11.75 87.09 87.09 0 004-10.56c.19-.54.34-1.07.5-1.6-.73-.58-1.45-1.17-2.2-1.73-.33.73-.68 1.48-1.08 2.25-1.35 3-3.13 6.18-5.11 9.62-1.08 1.68-2.07 3.5-3.28 5.26s-2.42 3.62-3.8 5.42c-2.7 3.65-5.54 7.5-8.82 11.22l-2.47 2.81-2.68 2.7c-1.75 1.87-3.74 3.53-5.66 5.31s-4 3.37-6.1 5-4.27 3.17-6.58 4.51l-3.43 2c-1.18.63-2.39 1.18-3.58 1.77a59.2 59.2 0 01-7.34 3c-5 1.46-10.24 2.71-15.06 3.73-2.38.61-4.82 1.27-7.19 1.92zM0 113.11H4.11c.94 0 1.94-.15 3-.26 2.07-.22 4.32-.53 6.69-.94a71.2 71.2 0 007.2-1.73 74.87 74.87 0 007.58-2.45c2.55-1 5.09-2 7.62-3.11s4.95-2.47 7.35-3.74 4.7-2.63 6.92-3.92 4.4-2.5 6.39-3.76l5.62-3.48c1.75-1 3.31-2.09 4.67-3l3.53-2.43 3.06-2.14-3.44 1.45-3.91 1.71c-1.5.67-3.21 1.4-5.11 2.09l-6.09 2.32c-2.14.87-4.53 1.47-6.92 2.25s-4.87 1.53-7.44 2.13-5.13 1.34-7.69 2-5.16 1.27-7.65 2-5 1.37-7.35 2l-3.49 1c-1.13.39-2.25.72-3.32 1-2.15.66-4.17 1.35-6 2.06l-5.12 2c-.13 2.2-.21 4.42-.21 6.65z"
          fill="#4c89d2"
        />
        <path
          d="M64.76 181.27c-13.39-1.48-27.49-2.41-40 2.2a113.65 113.65 0 0020.31 19.74c8.36-4.47 16.44-10.09 25.63-12.13 6.72-1.49 13.7-1 20.54-1.78s14-3.24 17.88-8.92c-14.12 4.62-29.54 2.52-44.36.89z"
          fill="#055899"
        />
        <path
          d="M164.8 155.33c-6.48 2.54-11.91 7.15-18 10.59s-13.5 5.68-19.93 3c10.28-8.92 24.49-11.45 37.93-13.59z"
          fill="#4c89d2"
        />
        <path
          d="M0 112.93a112.54 112.54 0 0010.27 47c40.08 10.16 81-3.18 111.42-35.42C153.21 91.1 164.6 46.23 149.58 6.12A112.91 112.91 0 000 112.93z"
          fill="#fff"
          opacity={0.15}
        />
        <g mask="url(#planet-neptune_svg__e)">
          <path
            d="M35.69 37.15c28.47-27.37 74-32.69 97.85-8.18s2.17 46.62-25.06 80.46c-22.37 27.79-60.83 51-84.69 26.53S7.21 64.51 35.69 37.15z"
            opacity={0.39}
            fill="url(#planet-neptune_svg__f)"
          />
        </g>
        <path
          d="M64.48 215.06A113 113 0 10112.93 0 113.22 113.22 0 0084 3.76a111.34 111.34 0 01124.09 161c-27.77 51.66-90.72 72.86-143.61 50.3z"
          style={{
            mixBlendMode: "screen",
          }}
          fill="#fff"
          opacity={0.24}
        />
      </g>
    </svg>
  );
}

export default SvgPlanetNeptune;
